import { RootState } from 'editor/src/store/index';

const getDeleteFrameWithImage = (state: RootState) => state.hostSettings.deleteFrameWithImage;

export default getDeleteFrameWithImage;
